<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4><router-link to="/config/security">{{ $t('Security') }}</router-link> / {{ $t('Change password') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">
      <form
        id="profile-password-form"
        class="form"
        v-on:submit.prevent="savePassword()"
        :class="{'box-loading': loading}">
        <div class="form-group">
          <label>{{ $t('New password') }}</label>
          <input v-autofocus type="password" class="form-control" v-model="pw.password">
          <ValidateMessage :error="validateErrors.password" />
        </div>
        <div class="form-group">
          <label>{{ $t('Confirm password') }}</label>
          <input type="password" class="form-control" v-model="pw.password_confirmation">
          <ValidateMessage :error="validateErrors.password_confirmation" />
        </div>
        <button
          type="submit"
          form="profile-password-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <router-link
          to="/config/security"
          class="btn btn-link">Voltar</router-link>
      </form>
    </div>

  </div>

</template>

<script>
export default {
  name: 'Password',
  components: {
  },
  data () {
    return {
      loading: false,
      pw: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    savePassword () {
      this.loading = true

      this.$store
      .dispatch('passwordRedefined', this.pw)
      .then(() => {
        this.redirect()
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    redirect () {
      this.$router.push('/config/security')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form {
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfilePassword.vue